import menu from './menu'
import commands from './commands'
import apikeys from './apikeys'
import endpoints from './endpoints'
import installation from './installation'

import { logger } from 'helpers'
var main = {}
try {
  main = require('../projects/' + process.env.REACT_APP_PROJECT + '/config/main')
} catch (e) {
  logger.debug('No project-specific config for main')
}
module.exports = {
  Installation: installation,
  Menu: menu,
  Commands: commands,
  ApiKeys: apikeys,
  Endpints: endpoints,
  Config: main
}



// WEBPACK FOOTER //
// ./src/config/index.js